import { render } from "./NovedadesAjustesCH.vue?vue&type=template&id=e001bab4"
import script from "./NovedadesAjustesCH.vue?vue&type=script&lang=js"
export * from "./NovedadesAjustesCH.vue?vue&type=script&lang=js"

import "./NovedadesAjustesCH.vue?vue&type=style&index=0&id=e001bab4&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__